import clsx from 'clsx';
import { Trans } from 'next-i18next/pages';
import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { SectionTitleBase, SectionTitleProps } from '@pflegia/ui/shared/section/SectionTitleBase.component';

import { useRouterHelper } from '@hooks/use-router-helper';

export const SectionTitle: React.FC<SectionTitleProps> = props => {
  const { className, id, level = 'h4', noMargin, t, titleKey } = props;
  const { isExternalJob } = useRouterHelper();
  const Heading = level;

  return isExternalJob ? (
    <Heading id={id} className={clsx('text-default text-lg font-bold lg:text-2xl', !noMargin && 'mb-6', className)}>
      <Trans components={{ span: <span /> }} i18nKey={titleKey} t={t} />
    </Heading>
  ) : (
    <SectionTitleBase {...props} />
  );
};

interface SectionProps {
  className?: string;
  children: ReactNode;
  noPadding?: boolean;
}

const Section: React.FC<SectionProps> = ({ className, children, noPadding }) => (
  <section className={twMerge(clsx('rounded-2xl bg-white', !noPadding && 'px-6 pt-4 pb-6 md:px-12 md:pt-12 md:pb-12', className))}>
    {children}
  </section>
);

export default Section;
